module.exports = __webpack_public_path__ + "img/2.aa88c83d.png";